// 引入静态路由
import { constantRoutes, asyncRouter } from '@/router'
import $lodash from "lodash"
const state = {
  //routes是路由表,默认有静态路由的权限
  routes: constantRoutes
}
const mutations = {
  //修改state里面的routes
  setRoutes (state, newRoutes) {
    state.routes = [...constantRoutes, ...newRoutes]
    // state.routes = $lodash.concat(constantRoutes, newRoutes)
  }
}
//筛选路由的方法
const computedAsyncRoutes = (asyncRoutes, routes) => {
  // const asyncRoutes1 = $lodash.cloneDeep(asyncRoutes)
  const arr1 = asyncRoutes.filter(item => routes.includes(item.name))
  arr1.forEach(item => {
    if (item.children && item.children.length > 0) {
      item.children = item.children.filter(item2 => routes.includes(item2.name))
    }
  })
  return arr1
}
// const computedAsyncRoutes = (asyncRoutes, routes) => {
//   let asyncRoutes1 = $lodash.cloneDeep(asyncRoutes)
//   let arr1 = asyncRoutes1.filter(item => {
//     if (routes.indexOf(item.name) != -1) {
//       return true
//     }
//   })
//   arr1.forEach(item => {
//     if (item.children && item.children.length > 0) {
//       item.children2 = item.children.filter(item2 => {
//         if (routes.indexOf(item2.name) != -1) {
//           return true
//         }
//       })
//     }
//   })
//   arr1.forEach(item => {
//     item.children = item.children2
//   })
//   return arr1
// }
const actions = {
  //调用筛选动态路由的方法
  filterRoutes (context, menus) {
    // menus.push(...'queryStatistics,protocolManagement,scaleCheck,indexCheck,loginLog,signManage,signCheck,healthWarning,indexManage,indexStatistics,indexDetail,patientStatistics'.split(","))
    let routes = computedAsyncRoutes(asyncRouter, menus)
    context.commit('setRoutes', routes)
    return routes
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}